module.exports = __webpack_public_path__ + "static/media/global_page.01d1bd3e.jpg";